export default __webpack_public_path__ + "static/media/notion.f361fdc5.svg";